/**
 * IFC-3d (F248, Infra-Doku meplora-bim-integration/26 §5.1): „IFC aus Datenkern“ in der Oberfläche.
 *
 * Art 200 `IfcAusDatenkern` erzeugt das IFC nicht in Revit, sondern auf einer Linux-Maschine (Art IFC) aus dem
 * eingefrorenen Kernstand eines Modells. Die Plattform nimmt den Auftrag nur mit dem Schalter `Bim:IfcExport` an.
 * Die Oberfläche bietet die Auswahl deshalb nur an, wenn der Server den Schalter meldet
 * (`ProjektDetail.ifcAusDatenkern`). Ein älterer Server ohne das Feld zeigt sie nicht.
 *
 * Ergebnis eines Teilauftrags: das Paket (`ifcausdatenkern`), die IFC-Datei (`ifc-datenkern`) und der Prüfbericht
 * (`ifc-bericht`, `bericht.json`). Die Artefaktarten stehen hier mit lesbarem Namen.
 */

/** ExportKind.IfcAusDatenkern (Server, BI/07 §2.3). */
export const ART_IFC_AUS_DATENKERN = 200;

/** Eine Exportart, die eine Modellzeile direkt beauftragen kann. */
export interface Exportaktion {
  art: number;
  name: string;
  titel: string;
}

/** Die Ausgabeformate der Modellzeile, „IFC aus Datenkern“ nur mit Schalter. */
export function exportaktionen(ifcAusDatenkern: boolean | undefined): Exportaktion[] {
  const aktionen: Exportaktion[] = [
    { art: 1, name: 'IFC', titel: 'IFC exportieren' },
    { art: 2, name: 'PDF', titel: 'Pläne als PDF' },
    { art: 3, name: 'DWG', titel: 'Pläne als DWG' },
  ];
  if (ifcAusDatenkern === true) {
    aktionen.push({
      art: ART_IFC_AUS_DATENKERN,
      name: 'IFC aus Datenkern',
      titel: 'IFC aus dem Datenkern (ohne Revit, aus dem aktiven Kernstand des Modells)',
    });
  }
  return aktionen;
}

const ARTEFAKTE: Record<string, string> = {
  'ifc-datenkern': 'IFC aus Datenkern',
  'ifc-bericht': 'IFC-Prüfbericht',
  ifcausdatenkern: 'IFC-Paket (Datenkern)',
};

/** Lesbarer Name einer Artefaktart; unbekannte Arten bleiben, wie der Server sie liefert. */
export function artefaktArtText(kind: string): string {
  return ARTEFAKTE[kind] ?? kind;
}
